(function () {
  const header = document.querySelector('.header'); // ヘッダーの外枠クラス（後述の確認が必要）

  if (!header) return;

  let ticking = false;

  function updateHeaderState() {
    if (window.scrollY > 300) {
      header.classList.add('fixed');
    } else {
      header.classList.remove('fixed');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  });
})();